import { FC } from 'react';

import { StyledLoading } from './Loading.styles';

const Loading: FC = () => <StyledLoading />;

export default Loading;
